import { render, staticRenderFns } from "./PagePushNotificationsSettings.vue?vue&type=template&id=011bbbe3&"
import script from "./PagePushNotificationsSettings.vue?vue&type=script&lang=ts&"
export * from "./PagePushNotificationsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports